/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Collection from './collection'
import _ from 'underscore'
import { popRootKey } from '../util'

/*
 * Public: Smart Collection is smarter when you call
 * reset(). For models already in the collection, it will
 * merge the attributes. For models that don't exist in the
 * collection, it will add them with an 'add' event on the model.
 * And for any models in the collection that
 * is not in the new set, it will be removed with a 'removed'
 * event on the model.
 *
 * @namespace Model
 */
export default class SmartCollection extends Collection {
  reset (models, options) {
    /*
     * This collection may contain models that are new
     * to persist to the server. These will not have an ID and
     * therefore cannot be merged. Remove them to prevent duplicates
     * after the merge has happened.
     */
    if (models == null) { models = [] }
    if (options == null) { options = {} }
    const toRemove = this.filter(m => m.isNew())
    this.remove(toRemove, options)

    // keep track of the current ids so we can merge/reorder properly
    const currentIds = this.pluck('id')

    /*
     * Incoming models may need to have their root key popped.
     * We try both schemes.
     */
    const newIds = _.map(models, model => model.id || popRootKey(model).id)

    // Need to unpack newIds
    const deleted = _.without.apply(this, [currentIds].concat(newIds))

    // Remove the old items
    _(deleted).each(id => {
      return this.remove(this.get(id), options)
    })

    // Add the new items
    this.add(models, _.extend({ merge: true }, options, { validate: false }))

    // only reorder if there are already some models
    let reordered = false
    if ((currentIds.length > 0) && (JSON.stringify(newIds) !== JSON.stringify(currentIds))) {
      // Put them in the same order
      const orderedModels = _.map(models, (model, index) => {
        return this.get(model.id || popRootKey(model).id)
      })

      _.each(orderedModels, (orderedItem, index) => {
        this.models[index] = orderedItem
      })

      reordered = true
    }

    if (!deleted.length && (currentIds.length === newIds.length) && reordered) {
      if (!options.silent) { this.trigger('reorder', this, options) }
    }

    // Trigger reset event
    if (!options.silent) { this.trigger('reset', this, options) }

    return this
  }
}
